import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




//DELETE A ROLE
const submit = (id) => client.delete(`roles/${id}`);
export const useDeleteRole = (id) => useMutation(['deleteRole',id],() => submit(id))